import { putApi } from '../../../utils/api'

export function updateSearchResultsRequestsTableConfig(data) {
  return putApi({
    data,
    endpoint: 'idwell-api/api/v3/table/tables/requests-search/config/',
  })
}
